import { HttpRequest } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import {
  AuthHttpHeaderService,
  AuthRedirectService,
  AuthService,
  AuthStorageService,
  AuthToken,
  GlobalMessageService,
  OAuthLibWrapperService,
  OCC_USER_ID_ANONYMOUS,
  OccEndpointsService,
  RoutingService,
  UserIdService,
} from '@spartacus/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShimanoAuthHttpHeaderService extends AuthHttpHeaderService implements OnDestroy {
  private currentUserId = OCC_USER_ID_ANONYMOUS;
  private userSub = new Subscription();

  constructor(
    authService: AuthService,
    authStorageService: AuthStorageService,
    oAuthLibWrapperService: OAuthLibWrapperService,
    routingService: RoutingService,
    occEndpoints: OccEndpointsService,
    globalMessageService: GlobalMessageService,
    authRedirectService: AuthRedirectService,
    private userIdService: UserIdService
  ) {
    super(
      authService,
      authStorageService,
      oAuthLibWrapperService,
      routingService,
      occEndpoints,
      globalMessageService,
      authRedirectService
    );

    this.userSub.add(this.userIdService.getUserId().subscribe((id) => (this.currentUserId = id)));
  }

  protected isSiteContextRequest(request: HttpRequest<any>): boolean {
    return request.url.includes('/occ/v2/site-contexts');
  }

  public override alterRequest(request: HttpRequest<any>, token?: AuthToken): HttpRequest<any> {
    // Skip token for site-contexts ONLY when the OCC user is anonymous.
    if (this.isSiteContextRequest(request) && this.currentUserId === OCC_USER_ID_ANONYMOUS) {
      console.log('The request is for site-context and the OCC user is anonymous. Alter request is skipped ');
      return request;
    }
    return super.alterRequest(request, token);
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }
}
